import { useLocation } from "react-router-dom";
import MultiUserId from "../../MultiUserId";
import routes from "../../../routes";
import { useAppSelector } from "../../../hooks/redux";
import { mergeClassName } from "../../../utils/helpers";
import WelcomeMenu from "./WelcomeMenu";
import ApplicationsMenu from "./ApplicationsMenu";
import ApplicationMenu from "./ApplicationMenu";
import LogoutButton from "../../LogoutButton";

type props = {
  className?: string;
};

// routes
const { applications } = routes.protected;

function SideNav({ className }: props) {
  const location = useLocation();
  const { user } = useAppSelector((state) => state.auth);
  const { email } = user;

  const renderMenu = () => {
    let template = <></>;
    switch (true) {
      case location.pathname.includes(applications.index):
        template = <ApplicationsMenu />;
        break;
      case location.pathname.includes(applications.app.index):
        template = <ApplicationMenu />;
        break;

      default:
        template = <WelcomeMenu />;
        break;
    }
    return template;
  };

  return (
    <nav
      className={mergeClassName(
        "grid grid-rows-[max-content_2.5rem_max-content_2.6fr_max-content_1fr_max-content] pl-12 pt-8  pb-5 2xl:pb-22 ",
        className,
      )}
    >
      {renderMenu()}
      {email && <LogoutButton />}
      <MultiUserId className="row-start-6 row-end-7 hidden select-none self-end text-center md:block" />
    </nav>
  );
}

export default SideNav;
